var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTemperatura(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123.74 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040006;}.cls-2{fill:#ea0000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-temperatura") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_22",
    "data-name": 22
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.51,11.06h.31c10.58.15,19.23,9.13,19.29,20,.07,14.28,0,28.82,0,42.87q0,9.53,0,19v12.68c0,16.34,0,33.24,0,49.85a16,16,0,0,0,6.39,13.3,42.23,42.23,0,1,1-52.51.11,16.36,16.36,0,0,0,6.52-13.54c-.06-37.66-.07-78.08,0-123.58,0-11.83,8.63-20.74,20-20.74M53.51,0C36,0,22.41,13.78,22.4,31.79q0,61.8,0,123.6a5.39,5.39,0,0,1-2.27,4.82,53.21,53.21,0,0,0,33,94.91,53.93,53.93,0,0,0,6.81-.44A53.2,53.2,0,0,0,86.31,160.1a5.06,5.06,0,0,1-2.15-4.56q.09-31.29,0-62.57c0-20.65.08-41.3,0-61.95C84.09,14,70.6.24,54,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109,118.35c-3,0-6.05.07-9.07,0-3.49-.1-5.54-2.09-5.47-5.12s2-4.84,5.4-4.89q9.22-.13,18.46,0c3.2.05,5.36,2.18,5.38,5s-2.12,4.92-5.32,5S112.17,118.35,109,118.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.24,46.09c3.13,0,6.25-.07,9.38,0s5.09,2.09,5.12,4.82a4.84,4.84,0,0,1-5,5q-9.67.13-19.36,0a4.7,4.7,0,0,1-4.91-5c0-2.84,2-4.76,5.06-4.84S106,46.09,109.24,46.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.87,149.46c-3,0-6.06.06-9.08,0-3.27-.08-5.29-2-5.29-5s1.93-4.89,5.28-4.93q9.39-.12,18.77,0c3.18,0,5.28,2.23,5.18,5.08s-2.15,4.73-5.18,4.81C115.32,149.52,112.09,149.46,108.87,149.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.88,87.12c-3,0-6,.06-9.07,0-3.35-.09-5.3-2-5.31-4.93s2-4.93,5.26-5q9.38-.11,18.76,0A4.94,4.94,0,0,1,123.73,82c.11,2.84-2,4.9-5.17,5.12h-9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.68,147.5c0,4.86.08,9.72,0,14.58-.11,5.27,2.12,8.92,6.6,11.74,11.6,7.3,17.13,18.07,15.61,31.63-1.56,13.94-9.58,23.41-23,27.78-15.5,5.06-32.47-2.64-39.39-17.47s-2-32.72,12-41.35c5.5-3.41,7.71-7.71,7.52-14-.28-9.31-.08-18.63-.07-27.94,0-6.48,4.23-11.17,10.16-11.3s10.54,4.57,10.6,11.17C63.71,137.38,63.68,142.44,63.68,147.5ZM52.36,225.41c3.29,0,5.36-1.61,5.47-4.35s-1.71-4.47-4.79-4.76c-7.92-.74-12.37-5.21-13.17-13.21-.31-3-2.21-4.93-4.8-4.83s-4.3,2.1-4.33,5.18C30.65,214.92,40.84,225.28,52.36,225.41Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTemperatura);
export default __webpack_public_path__ + "static/media/ic-temperatura.d1900827a7fa3bbebe8a9857225cac82.svg";
export { ForwardRef as ReactComponent };